import React from 'react';

const Report: React.FC<{ onNavigate: (screen: string) => void }> = ({ onNavigate }) => {
  return (
    <div className="container" style={{ maxWidth: 900, margin: '0 auto', padding: 24 }}>
      <h1 style={{ fontSize: 28, fontWeight: 700, marginBottom: 8 }}>Mock EagleView Roof Report</h1>
      <p style={{ color: '#6b7280', marginBottom: 24 }}>Property: 1247 Oak Street, Nashville, TN 37203</p>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16, marginBottom: 24 }}>
        <div style={{ background: 'white', border: '1px solid #e5e7eb', borderRadius: 8, padding: 16 }}>
          <h3 style={{ marginBottom: 8 }}>Measurements</h3>
          <ul style={{ color: '#374151' }}>
            <li>Total Roof Area: 2,850 sq ft</li>
            <li>Ridge Length: 110 ft</li>
            <li>Hip Length: 80 ft</li>
            <li>Valley Length: 65 ft</li>
            <li>Pitch: 6/12</li>
          </ul>
        </div>
        <div style={{ background: 'white', border: '1px solid #e5e7eb', borderRadius: 8, padding: 16 }}>
          <h3 style={{ marginBottom: 8 }}>Imagery</h3>
          <div style={{ height: 200, background: '#e5e7eb', borderRadius: 8, display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#6b7280' }}>
            Aerial Image Placeholder
          </div>
        </div>
      </div>

      <div style={{ background: 'white', border: '1px solid #e5e7eb', borderRadius: 8, padding: 16, marginBottom: 24 }}>
        <h3 style={{ marginBottom: 8 }}>Property Details</h3>
        <ul style={{ color: '#374151' }}>
          <li>Year Built: 1998</li>
          <li>Stories: 2</li>
          <li>Layers: 1 (tear-off required)</li>
          <li>Primary Material: Asphalt Shingles</li>
        </ul>
      </div>

      <div style={{ display: 'flex', gap: 12 }}>
        <button className="btn btn-secondary" onClick={() => onNavigate('customer-dashboard')}>Back</button>
        <button className="btn btn-primary" onClick={() => onNavigate('customer-dashboard')}>Go to Dashboard</button>
      </div>
    </div>
  );
};

export default Report;